import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8dedc5c185aba8d/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/app/[locale]/online-ordering-webshop/WebshopPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8dedc5c185aba8d/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8dedc5c185aba8d/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8dedc5c185aba8d/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8dedc5c185aba8d/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8dedc5c185aba8d/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8dedc5c185aba8d/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
